import type { UserDevice } from '../schemas/userDevice';

// Device telemetry keyed by USER ID, mirroring the three states the ficha must show:
// a populated device, "no device" (200 → null), and a transient failure (the device
// card surfaces an inline retry without taking the account card down).
const DEVICES: Record<string, UserDevice | null> = {
  '330148': {
    appVersion: '4.18.2',
    os: 'iOS',
    osVersion: '17.4',
    model: 'iPhone 13',
    carrier: 'Movistar',
  },
  // Web-only / never installed the app.
  '330149': null,
};

const ERROR_IDS = new Set(['330150']);

export async function fetchUserDeviceMock(id: string): Promise<UserDevice | null> {
  // Simulate network latency for a realistic dev experience.
  await new Promise((resolve) => setTimeout(resolve, 100));
  if (ERROR_IDS.has(id)) {
    throw new Error('device telemetry unavailable');
  }
  return DEVICES[id] ?? null;
}
